import { Component, Input } from '@angular/core';

@Component({
  selector: 'dgx-profile-settings-error-message',
  templateUrl: './error-message.component.html',
})
export class ProfileSettingsErrorMessage {
  @Input() public show: boolean;
  @Input() public message: string;
}
